const translation = {
  1033: 'Inventario',
  1034: 'Tienda',
  1530: 'Ya tienes una suscripción',
  1531: '¿Estás seguro de que quieres comprar una suscripción?',
  1532: "Costará <img src='/svgs/dominion.svg' style='margin: 0px 10px -10px 10px'/> {{ param1 }}?",
  1533: "Abre una <span style='color: #FF9326;font-size: 28px'>TIENDA PERSONAL</span> </br>para tu estructura de jugadores",
  1534: "¿Alquilar por <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -5px 2px; width: 20px'/> {{ param1 }} Loyalty Coin?",
  1535: '¿Estás seguro de que quieres alquilar el Hexatile #{{ param1 }}?',
  1536: "Costará <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -3px 2px'/> {{ param1 }} Loyalty Coin",
  1537: 'El alquiler se cobrará cada 30 días',
  1538: '¿Estás seguro de que quieres seleccionar este Asesor?',
  1539: "El servicio de <span style='color: #FF9326'>Territory X</span> <span style='color: #FF9326'>NO</span> se aplica a las áreas alquiladas.",
  1540: 'Has seleccionado alquilar {{ param1 }} Hexatiles',
  1541: 'Necesario para el alquiler',
  1542: '2 años',
  1543: 'El Hexatile #{{ param1 }} está alquilado',
  1544: 'Puedes verlo en el mapa en el dominio 2 del Asesor',
  1545: '¿Estás seguro de que quieres seleccionar este Asesor?',
  1546: 'El servicio de Territory X NO se aplica a las áreas alquiladas.',
  1547: '¿Estás seguro de que quieres colocar un Orbe en un Hexatile alquilado?',
  1548: 'Si termina el alquiler, el orbe dejará de pertenecerte.',
  1549: '({{ param1 }} alquilados)',
  1550: 'Hexatiles alquilados',
  1551: '¿Estás seguro de que quieres mover / vender el último Hexatile?',
  1552: 'Si no queda ningún Hexatile en este Asesor, entrará en HIBERNACIÓN. Puede permanecer vacío 7 días, después será destruido.',
  1553: 'No hay ni un solo Hexatile (alquilado o comprado) en este Asesor.',
  1554: 'Puede permanecer vacío en estado de hibernación durante 7 días, después será destruido.',
  1555: 'Llena el Asesor con Hexatiles (compra o alquila) para sacarlo de la hibernación.',
  1556: 'Puedes obtener Loyalty Coin entrando en Masters of Game todos los días y completando misiones (próximamente)',
  1557: 'Loyalty Coin es una moneda especial destinada al alquiler de parcelas en Legends Of Interaction. La moneda solo puede ser usada por un Master of Game. Puedes obtener Loyalty Coin entrando en Masters of Game todos los días y completando misiones (próximamente)',
  1558: '{{ param1 }} se ha quedado vacío y ha entrado en HIBERNACIÓN durante 7 días.',
  1559: ' Llénalo con Hexatiles (compra o alquila), o será destruido.',
  1560: 'No hay ni un solo Hexatile (alquilado o comprado) en este Asesor.',
  1561: 'Puede permanecer vacío en estado de hibernación durante 7 días, después será destruido.',
  1562: 'Llena el Asesor con Hexatiles (compra o alquila) para sacarlo de la hibernación.',
  1563: 'Bienvenido a <br/> MASTERS OF GAME',
  1564: "Recompensas del <span style='color: #FF9326'>DÍA {{ param1 }}</span> :",
  1565: "Recompensas de la <span style='color: #FF9326'>SEMANA</span> :",
  1566: "Recompensas del <span style='color: #FF9326'>MES</span> :",
  1567: "<span style='color: #FF9326'>{{ param1 }}</span> Hexatiles <br/> movidos correctamente.",
  1568: "Puedes verlo en el mapa en el dominio <span style='color: #FF9326'>{{ param2 }}</span>.",
  1569: 'No activado',
  1570: '¿Estás seguro de que quieres activar / actualizar Territory X?',
  1571: '¿Estás seguro de que quieres cancelar esta compra?',
  1572: "Esta acción finalizará la puja y la información del hexatile volverá a la pestaña «<span style='color: #FF9326'>World</span>»",
  1573: 'Sí, quiero cancelar la compra',
  1574: 'No, volver a las pujas',
  1575: 'Solo puedes ver y colocar Orbes con ZOOM 19 o más.',
  1576: "Por favor, <span style='color: #FF9326'>amplía</span> el mapa.",
  1577: 'Los Orbes solo pueden colocarse en Hexatiles comprados.',
  1578: 'Selecciona un Hexatile que te pertenezca.',
  1579: 'Tus órdenes de VENTA se eliminarán automáticamente después de 10 días si no hay ofertas de compra.',
  1580: 'Míralo en el mapa para ver los detalles.',
  1581: 'Quedan {{ param1 }} días',
  1582: 'Tu orden de VENTA se eliminará automáticamente después de 10 días si no hay ofertas de compra',
  1583: "El Hexatile #{{ param1 }} se vendió por <img src='/svgs/reex.svg' style='margin: 0px 5px -10px 3px'/> {{ param2 }}",
  1584: 'Esta oportunidad solo está disponible para los participantes del grupo focal. <br/> Si te interesa, contacta con la persona que te invitó aquí.',
  1585: 'Códigos de referido:',
  1586: 'Los códigos se actualizan automáticamente tras la activación.',
  1587: 'No disponible',
  1600: 'Disponible: {{param1}}',
  1601: 'Haz clic para colocar',
  1602: 'Amplía hasta el nivel {{param1}} para colocar un minero',
  1603: 'Aún no hay mineros',
  1604: 'Minero',
  1605: 'Disponible para recoger',
  1606: 'Total recogido',
  1607: 'Última recogida',
  1608: 'El minero está lleno y se ha detenido. Recoge los REEX para que siga minando',
  1609: 'Haz clic para recoger',
  1610: 'Aún no hay nada que recoger',
  1611: 'Mis maestros',
  1612: 'Mi tienda',
  1613: 'LOI Referral',
  1614: 'Plantillas',
  1615: 'Crear',
  1616: 'Vista previa',
  1617: 'Suscripción',
  1618: 'Se requiere suscripción de tienda',
  1619: 'Para tener una tienda se necesita una suscripción activa de creador de mercado.',
  1620: 'Ir a la suscripción',
  1621: 'Aún no hay plantillas',
  1622: 'Crea la primera',
  1623: 'Así ven tu tienda los compradores',
  1624: 'Ninguna plantilla está a la venta: los compradores ven una tienda vacía',
  1625: 'Suscripción de tienda',
  1626: 'La suscripción está activa',
  1627: 'Sin suscripción',
  1628: 'Válida hasta {{param1}}',
  1629: 'Renovar o comprar',
  1630: 'Comprar',
  1631: '1 año',
  1632: '2 años',
  1633: '3 años',
  1634: '99 años',
  1635: '¿Comprar la suscripción «{{param1}}» por {{param2}} {{param3}}?',
  1636: 'El pago de la suscripción estará disponible pronto',
  1637: 'A la venta: {{param1}}',
  1638: 'No está a la venta',
  1639: '{{param1}} artículos',
  1640: 'Descripción',
  1641: 'Precio',
  1642: 'A la venta: {{param1}}',
  1643: 'No está a la venta',
  1644: 'Contenido de la plantilla ({{param1}})',
  1645: 'El paquete está vacío.',
  1646: 'Eliminar',
  1647: 'Precio (Reex)',
  1648: 'A la venta',
  1649: 'Guardar',
  1650: 'Retirar de la venta',
  1651: 'Crear una plantilla',
  1652: 'Orbes',
  1653: 'Monedas',
  1654: 'Aquí está vacío',
  1655: 'Imagen de la plantilla',
  1656: 'Subir imagen',
  1657: 'Cambiar imagen',
  1658: 'Nombre de la plantilla',
  1659: 'En la plantilla ({{param1}})',
  1660: 'Cancelar',
  1661: 'Creando...',
  1662: 'Demasiados',
  1663: 'Aún no hay ofertas',
  1664: 'Compra no disponible',
  1665: 'Eres un creador de mercado.',
  1666: 'Quedan: {{param1}}',
  1667: 'Vendedor',
  1668: 'Precio por paquete',
  1669: 'Contenido del paquete ({{param1}})',
  1670: 'No hay datos sobre el contenido.',
  1671: 'Cantidad',
  1672: 'Total',
  1673: 'Vista previa: compra no disponible',
  1674: 'Comprado: {{param1}} ×{{param2}}',
  1675: '¿Comprar «{{param1}}» ×{{param2}} por {{param3}} Reex?',
  1676: 'Incorporaciones:',
  1677: 'Cantidad (± a la venta)',
  1678: 'Añadir a la venta',
  1679: 'Poner a la venta',
  1680: 'Recompensa recogida',
  1681: 'Recogido: {{param1}} REEX',
  1682: 'Desde',
  1683: 'Hasta',
  1684: 'Mostrar',
  1685: 'Exportar CSV',
  1686: 'Recurso',
  1687: 'Transacciones',
  1688: 'Informe',
  1689: '{{param1}} año',
  1690: '{{param1}} años',
  1691: 'El plazo se añadirá a tu fecha de vencimiento actual.',
  1692: 'Tras esta compra te convertirás en creador de mercado y saldrás de tu estructura actual.',
  1693: 'Comprar Dominion',
  1694: 'CANTIDAD',
  1695: 'MONEDA DE PAGO',
  1696: 'Pronto',
  1697: 'Saldo: {{param1}}',
  1698: 'Criptomoneda',
  1699: 'Red {{param1}}',
  1700: 'Total:',
  1701: 'NO HAY SUFICIENTE {{param1}}',
  1702: 'COMPRAR {{param1}} {{param2}}',
  1703: 'Tasa: {{param1}} REEX por 1 {{param2}}. Otros métodos de pago se añadirán más adelante.',
  1704: 'Comprado {{param1}} {{param2}}',
  1705: '¿Comprar {{param1}} {{param2}} por {{param3}}?',
  1706: 'Ofertas personales',
  1707: 'Un precio especial para cierta cantidad de paquetes destinado a un jugador concreto de tu estructura. Las ofertas personales se aplican antes que el precio normal y desaparecen cuando se agotan.',
  1708: 'Jugador',
  1709: 'No hay ofertas personales para esta plantilla',
  1710: 'Añadir',
  1711: '¿Eliminar la oferta personal para {{param1}}?',
  1712: 'Precio personal',
  1713: 'Precio personal para los primeros {{param1}} paquetes',
  1714: '{{param1}} a precio personal, {{param2}} a precio normal',
  1715: 'Venta',
  1716: 'Jugador #{{param1}}',
  1717: 'Personales: {{param1}}',
  1718: 'Cargando la tasa…',
  1719: 'No se pudo cargar la tasa de cambio. La compra no está disponible temporalmente.',
  1720: 'Reintentar',
  1721: 'TASA NO DISPONIBLE',
  1722: 'Enlace de referido',
  1723: 'Obtener maestros',
  1724: 'Maestros del Juego',
  1725: 'En esta sección podrá pedir recibir los Maestros del Juego a través de campañas publicitarias globales. Para realizar una solicitud, deberá enviar un token especial 1GM a su dirección interna destinada a la recepción de recursos. Para obtener más información sobre 1GM, consulte a sus Creadores de Mercado de nivel superior.',
  1726: 'Ilimitada',
  1727: 'Válida para siempre',
  1728: 'Tienes una suscripción ilimitada: no hay nada más que comprar.',
  1729: 'Obtenga sus propios Maestros del Juego a través de una campaña publicitaria global',
  1730: 'Usted puede pedir para sí mismo el registro de',
  1731: 'Pedir',
  1732: 'La posibilidad de solicitar el registro de Maestros del Juego se habilitará más adelante.',
  1733: 'Amplía hasta el nivel {{param1}} para mover los orbes',
  1734: '1GM es un token especial que se usa para solicitar el registro de Maestros del Juego a través de campañas publicitarias globales. Para saber más sobre 1GM, consulte a sus Creadores de Mercado de nivel superior.',
  1735: 'SOPORTE',
  1736: 'Nuevo ticket',
  1737: 'Asunto',
  1738: 'Mensaje',
  1739: 'Crear ticket',
  1740: 'Aún no tienes tickets',
  1741: 'Volver a los tickets',
  1742: 'Escribe una respuesta',
  1743: 'Responder',
  1744: 'Abierto',
  1745: 'Cerrado',
  1746: 'Soporte',
  1747: 'Tú',
  1748: 'Este ticket está cerrado, ya no puedes responder.',
  1749: 'Cancelar',
  1750: 'Aún no hay mensajes en este ticket',
  1751: 'Respondido',
  1752: 'ORB',
  1753: 'R-ORB',
  1754: 'R-ORB MAP',
  1755: 'REEX MINER',
  1756: 'Artículo',
  1757: 'Esta sección solo está disponible para los creadores de mercado',
  1758: 'Acierta a un dron y obtén {{param1}} Loyalty coins. Cada disparo cuesta {{param2}} Loyalty coin.',
  1759: 'Regístrate para participar',
  1760: 'Recarga tu saldo para continuar',
  1761: 'Recargar',
  1762: 'Precio en otras monedas',
  1763: 'Para recoger hay que acumular al menos {{param1}} REEX',
  1764: 'Pulso',
  1765: 'Pulso de la tienda',
  1766: 'La facturación y todo lo que la explica. Esta pantalla responde a la pregunta «por qué pago la suscripción».',
  1767: 'INGRESOS, ÚLTIMO MES',
  1768: '{{param1}} ventas',
  1769: 'SU PUESTO',
  1770: 'de {{param1}} tiendas en el último mes',
  1771: 'sin ventas en el último mes',
  1772: 'TIERRAS VACÍAS',
  1773: 'parcelas de sus maestros sin ningún objeto',
  1776: 'CAPACIDAD',
  1777: 'tantos paquetes están a la venta ahora mismo',
  1785: 'Maestros con tierras vacías',
  1787: 'La analítica aparecerá cuando el servidor empiece a enviarla',
  1790: 'Aún no hay datos',
  1793: '{{param1}} de {{param2}} parcelas vacías',
  1794: 'Todas las tierras de sus maestros están construidas',
  1795: 'Ranking de ventas, último mes',
  1796: 'ranking anónimo de todas las tiendas por ventas en el período',
  1797: 'Su tienda',
  1798: 'Mis datos',
  1799: 'Ranking',
  1800: 'Se puede poner en venta: {{param1}}',
  1801: 'Máximo {{param1}} con los activos actuales',
  1802: 'No hay suficientes activos para poner más en venta',
  1803: 'Tienda',
  1804: 'Mis solicitudes',
  1805: 'Solicitudes',
  1806: 'Indique a su market maker lo que necesita',
  1807: 'Nueva solicitud',
  1808: '{{param1}} de {{param2}} solicitudes',
  1809: 'Aún no hay solicitudes',
  1810: 'Paquetes: {{param1}}',
  1811: '{{param1}} Reex por paquete',
  1812: 'Total: {{param1}} Reex',
  1813: 'Elija lo que quiere comprar',
  1814: 'En la solicitud ({{param1}})',
  1815: 'Aún no ha seleccionado nada',
  1816: 'Número de paquetes',
  1817: 'Precio por paquete (Reex)',
  1818: 'Crear solicitud',
  1819: 'Solicitudes de sus maestros',
  1820: 'Sus maestros aún no han solicitado nada',
  1821: 'Cerrar solicitud',
  1822: 'Límite alcanzado: elimine una solicitud para crear una nueva',
  1823: 'No hay recursos disponibles para solicitudes',
  1824: 'Lo que sus maestros quieren comprar. Cierre la solicitud cuando esté cumplida.',
  1825: 'El juego está en beta temprana',
  1826: 'Legends of Interactions está en una etapa temprana de desarrollo. Las funciones y el contenido todavía se están añadiendo y pueden cambiar de una versión a otra.',
  1827: 'La versión actual del juego está disponible en el sitio web oficial',
  1828: 'Descargar el juego',
  1829: 'Códigos de invitación a LOI',
  1830: 'ACUMULADO',
  1831: 'Haga clic en el orbe para recoger',
  1832: 'Todavía no se ha acumulado nada',
  1833: 'Extras',
  1834: 'Funciones especiales del juego',
  1835: 'Emuladores de jugadores',
  1836: 'Vincule un emulador a un asesor y recogerá recursos por usted.',
  1837: 'EMULADORES LIBRES',
  1838: 'Vincular emulador',
  1839: 'Activo',
  1842: 'No hay emuladores libres',
  1843: '¿Vincular un emulador al asesor «{{param1}}»?',
  1844: 'El emulador empezará a recoger recursos para este asesor.',
  1847: 'Todavía no tiene asesores',
  1848: 'Hexágonos: {{param1}} / {{param2}}',
  1851: 'Principal',
  1852: 'Activo desde {{param1}}',
  1853: 'BATERÍA',
  1854: 'Devolver al inventario',
  1855: '¿Devolver el emulador del asesor «{{param1}}» al inventario?',
  1856: 'El emulador dejará de recoger recursos y volverá a estar libre.',
}

export default translation
